import { render, staticRenderFns } from "./OffersTable.vue?vue&type=template&id=dd87f0e2&scoped=true&"
import script from "./OffersTable.vue?vue&type=script&lang=ts&"
export * from "./OffersTable.vue?vue&type=script&lang=ts&"
import style0 from "./OffersTable.vue?vue&type=style&index=0&id=dd87f0e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd87f0e2",
  null
  
)

export default component.exports